'use client'

import { StickyBanner } from '@/components/ui/sticky-banner'
import { useGetPublicStatusBannerQuery } from '@/lib/api/statusBannerApi'
import { AlertTriangle } from 'lucide-react'

interface OutageStatusBannerProps {
  message?: string
}

export const OutageStatusBanner = ({ message }: OutageStatusBannerProps) => {
  const { data: statusBannerData } = useGetPublicStatusBannerQuery()

  // Determine if we should show the banner and what message to display
  const shouldShowHardcoded = message
  const shouldShowApi = statusBannerData?.data?.isEnabled && statusBannerData.data.message?.trim()

  if (!shouldShowHardcoded && !shouldShowApi) {
    return null
  }

  // Use API message if available, otherwise use hardcoded message
  const displayMessage =
    shouldShowApi && statusBannerData?.data
      ? statusBannerData.data.message
      : message || 'System maintenance in progress'

  return (
    <StickyBanner className="border-orange-200 bg-orange-100">
      <div className="flex w-full items-center justify-center gap-2">
        <AlertTriangle className="h-4 w-4 text-orange-600" />
        <p className="text-sm font-medium text-orange-800">{displayMessage}</p>
      </div>
    </StickyBanner>
  )
}

// Keep backward compatibility alias
export const MetaOutageBanner = OutageStatusBanner

export default OutageStatusBanner
